/**
 * SPSelection defines SP Selection for Open/BettingHistory purchase.
 *
 * @typedef SPSelection
 * @type {Object}
 * @property {id} Unique Id in the selection
 * @property {lineId} Unique identifier
 * @property {lineGroupId} Unique identifier of the group of the linq
 * @property {rowTypeId} type of row
 * @property {isOption} boolean is Optional
 * @property {isRegular} Is the lin e regular selection
 * @property {eventId} EventId of the current selection
 * @property {odds} Odds of the current Selection
 * @property {orgOdds} Original odds of the current selection
 * @property {clientOdds} Odds in the client OddsStyle
 * @property {branchId} brachId for the event
 * @property {leagueId} Id of the league
 * @property {masterLeagueId} masterLeagueId of the league
 * @property {splitTypeId} SplitTypeId of the selection
 * @property {eventTypeId} eventTypeId of the market
 * @property {eventGroupId} eventGroupId of the market
 * @property {isLive} was the selection placed live
 * @property {qPar1} qaParameter1 used for additional information
 * @property {qPar2} qaParameter2 used for additional information
 * @property {orderId} orderId used for sorting
 * @property {branchName} branchName Name of the branch
 * @property {eventName} name of the Event
 * @property {eventTypeName} name of the event/market type
 * @property {eventDate} date of the market/event
 * @property {leagueName} Name of the league
 * @property
 */

export class SPSelection {
    id: number;
    selectionId: number;
    lineId: number;
    statusId: number;
    lineGroupId!: number;
    rowTypeId: number;
    isOption: boolean;
    isRegular: boolean;
    eventId: string;
    odds: number;
    orgOdds: number;
    clientOdds: string;
    points: number;
    branchId: string;
    leagueId: string;
    masterLeagueId: string;
    splitTypeId!: number;
    eventTypeId: string;
    eventGroupId: number;
    isLive: boolean;
    qPar1: number;
    qPar2: number;
    orderId: number;
    branchName: string;
    leagueName: string;
    eventName: string;
    eventTypeName: string;
    eventDate: Date;
    result : string;

    constructor(source: SPSelection) {
        this.id = source.id;
        this.selectionId = source.selectionId;
        this.lineId = source.lineId;
        this.branchId = source.branchId;
        this.leagueName = source.leagueName;
        this.leagueId = source.leagueId;
        this.statusId = source.statusId;
        this.eventDate = source.eventDate;
        this.rowTypeId = source.rowTypeId;
        this.isOption = source.isOption;
        this.isRegular = source.isRegular;
        this.eventId = source.eventId;
        this.odds = source.odds;
        this.orgOdds = source.orgOdds;
        this.clientOdds = source.clientOdds;
        this.points = source.points;
        this.branchId = source.branchId;
        this.leagueId = source.leagueId;
        this.masterLeagueId = source.masterLeagueId;
        this.eventTypeId = source.eventTypeId;
        this.eventGroupId = source.eventGroupId;
        this.isLive = source.isLive;
        this.qPar1 = source.qPar1;
        this.qPar2 = source.qPar2;
        this.orderId = source.orderId;
        this.branchName = source.branchName;
        this.leagueName = source.leagueName;
        this.eventName = source.eventName;
        this.eventTypeName = source.eventTypeName;
        this.result = source.result;
    }
}